export const en = {
    active: 'Data collection in progress.',
    'active-text': 'Intermediate results are available, but the final results may be different.',
    brandlift: 'Brand Lift analysis',
    cancel: 'Cancel',
    close: 'Close',
    completed: 'Survey complete.',
    draft: 'Draft.',
    'draft-text': 'Data collection will start after your survey passes moderation.',
    moderation: 'Submitted for moderation.',
    'moderation-text': 'Data collection will start after your survey passes moderation.',
    'more-info-link': 'Learn more',
    params: 'Survey parameters',
    reject: 'The survey did not pass moderation.',
    result: 'Survey results',
    save: 'Save',
    stop: 'The survey has been stopped.',
    'stop-budget': 'Projected campaign budget is less than {currencySymbol}{budgetThreshold}.',
    'stop-budget-and-coverage': 'The projected budget and reach are below the minimum. {moreInfoLink}',
    'stop-coverage': 'Projected campaign reach is less than 2 million.',
    'stop-research': 'Cancel analysis'
};
